// extracted by mini-css-extract-plugin
export default {"profile-tabs":"ProfileTabs_profile-tabs__35krY","active":"ProfileTabs_active__Z4Ra8","chevron-mobile":"ProfileTabs_chevron-mobile__lBOnY","link-box":"ProfileTabs_link-box__5vNlo"};